import store from '@store';

const getDeviceType = () => {
  const deviceInfo = store.getState()?.oauth?.deviceInformation || {};
  const seat = store.getState()?.orders?.seats || {}

  const deviceTypeId = deviceInfo.deviceTypeId;
  const startMode = deviceInfo?.deviceGroup?.startMode;
  const isServerApp = deviceTypeId === 7 || deviceTypeId == null;

  const sourceType = seat?.sourceType;
  return {
    isServerApp,
    isWalkUp: false, // deprecated
    isSpeedOrderMode: sourceType === 11,
    isTogo: isServerApp && sourceType === 8,
    isDriveThru: isServerApp && startMode === 3,
    isCounter: startMode === 1,
    isCallCenter: isServerApp && startMode === 2,
    isDefaultMode:
      !(deviceTypeId === 7) &&
      !(deviceTypeId === 11) &&
      !(isServerApp && deviceTypeId === 8) &&
      (!deviceInfo.deviceGroup || startMode === 0),
    isFireboard: deviceTypeId === 15,
    isKiosk: deviceTypeId === 3,
    isTableTop: deviceTypeId === 10,
    isCubby: deviceTypeId === 11,
    isOrderUp: deviceTypeId === 8,
    isKds: deviceTypeId === 14,
    isPaymentTerminal: deviceTypeId === 6,
  };
};

export default getDeviceType;
